import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.TrackingCategoriesPopupContent', {
    title: 'Settings for {name}',
    saveButton: 'Save',
    description: `While sync with Xero this budget was pulled without Tracking categories.{br}Please set tracking categories manually for correct budgeting.`,
    learnMore: 'Learn more',
    agreement:
        'Please acknowledge that selected values won’t be overwritten by further syncs, unless the specified values are synced from XERO',
});
